import clsx from 'clsx';

type Variant = 'default' | 'knockout' | 'highlight' | 'button';

const Pill = ({
  variant = 'default',
  children,
}: {
  variant: Variant;
  children: React.ReactNode;
}) => {
  return (
    <span
      className={clsx(
        'cur-inline-flex cur-px-[8px] cur-py-[4px] cur-rounded-full',
        'cur-text-[10px] cur-uppercase cur-font-bold cur-leading-[133%] cur-tracking-[0.5px]',
        {
          default: 'cur-bg-cool-lavender cur-text-navy',
          knockout: 'cur-bg-white cur-text-navy',
          highlight: 'cur-bg-surface-dark-bold cur-text-white',
          button:
            'cur-bg-white cur-text-vivid-purple cur-border cur-border-cool-gray',
        }[variant],
      )}
    >
      {children}
    </span>
  );
};

export { Pill };
